/*
 * @Author: Jarun
 * @Date: 2021-03-24 19:03:31
 * @LastEditTime: 2021-04-07 17:35:37
 * @LastEditors: Please set LastEditors
 * @Description: 核心文件初始化
 * @FilePath: \box.mengw.com\src\main.ts
 */
import 'babel-polyfill';
import './assets/js/lib/flat';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

import { createApp } from 'vue';
import { Toast } from 'vant';
import AppVue from './App.vue';
import '@/assets/less/app.less';
// import cloudApp from '@9377/box-cloud-app';
import router from './router';
import store from './store';
import '@/assets/css/common/animate.min.css';
import 'vant/lib/index.css'
import '@vant/touch-emulator';
//vsconle的监控，测试可删除
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()

// 全局错误处理
window.addEventListener('error', (event) => {
    console.log('全局错误:', event);
    // 防止DOM相关错误导致整个应用崩溃
    if (event.error && event.error.message &&
        (event.error.message.includes('Node') ||
         event.error.message.includes('DOM'))) {
        event.preventDefault();
    }
}, true);

// 捕获未处理的Promise异常
window.addEventListener('unhandledrejection', (event) => {
    console.log('未处理的Promise异常:', event.reason);
    // 防止路由相关Promise异常影响用户体验
    if (event.reason && event.reason.name === 'NavigationDuplicated') {
        event.preventDefault();
    }
});

// 全局导航错误计数器
window._routeErrorCount = {};

// 全局历史状态管理，防止路由问题
window.addEventListener('popstate', function(event) {
    console.log('检测到历史状态变化:', document.location, event.state);

    // 如果URL中包含access_token参数并且当前路径包含sdk
    if (document.location.href.includes('access_token') &&
        document.location.pathname.includes('/sdk')) {
        console.log('检测到带token的SDK页面导航');

        // 防止页面被重定向出SDK页面
        const currentPath = document.location.pathname;
        if (currentPath.indexOf('/sdk') > -1) {
            event._sdkNavigation = true;
        }
    }
});

window.Config = { // 全局公用变量
    host: import.meta.env.VITE_PROXY_DOMAIN_REAL,
    userHost: import.meta.env.VITE_PROXY_USER_DOMAIN_REAL,
    cloudPayHost: import.meta.env.VITE_PROXY_CLOUD_PAY_REAL,
    currencyHost: import.meta.env.VITE_PROXY_CURRENCY_DOMAIN_REAL,
    authHost: import.meta.env.VITE_AUTH_DOMAIN,
    authLoginPath: import.meta.env.VITE_AUTH_LOGIN_PATH,
    authRealnamePath: import.meta.env.VITE_AUTH_REALNAME_PATH,
    env: import.meta.env.VITE_APP_MODE,
    platform: import.meta.env.VITE_PLATFORM,
    version: '1.0.0', //自定义版本号
    timeDiff: 30 * 60 * 1000, //登录行为上报时间间隔
    keyCode: 'PnV8QYQcD8xdZhafEb6XpAAvVfNbUJtg', //加密key
    rebackUrl: '', //安卓壳包时，一键登录时做的 登录成功跳转页面
    isAndroid: false,   //是否安卓环境，这里是登录页面需要用到的判断
    isSdk: false,   //是否sdk环境
    realnameLock: false, //是否锁定实名页面
    cloudappClient: {}, //云手机对象
    companyId: import.meta.env.VITE_COMPANY_ID,
    kefuUrl: '',
    appName: '',
    feedbackUrl: '',
    zzmg_switch: import.meta.env.VITE_ZZMG_SWITCH,
    dhsc_address: import.meta.env.VITE_DHSC_ADDRESS
};

// 根据平台设置客服链接和应用名称
if (window.Config.platform === 'm9377') {
    window.Config.kefuUrl = 'https://wvw.9377.cn/qy_kefu.php?source=9';
    window.Config.appName = '9377大师';
    window.Config.feedbackUrl = 'https://wj.qq.com/s2/16136228/fd09/';
    window.Config.default_game_id = '51211';
} else if (window.Config.platform === 'mengw') {
    window.Config.kefuUrl = 'https://api.mengw.com/kefu/qy';
    window.Config.appName = '梦玩盒子';
    window.Config.feedbackUrl = 'https://wj.qq.com/s2/19782001/4tca/';
    window.Config.default_game_id = '3024';
} else if (window.Config.platform === 'chuangyue') {
    window.Config.kefuUrl = 'https://api-pt.chuangyuejoy.com/kefu/qy?source=PC';
    window.Config.appName = '蔚蓝星球社区';
    window.Config.feedbackUrl = 'https://www.chuangyuejoy.com/yydwlxq/kefu/';
    // window.Config.default_game_id = '44';
    window.Config.default_game_id = '171';
}

// 立即更新页面标题
if (document.title === '' && window.Config.appName) {
    document.title = window.Config.appName;
}

console.log(window.Config.platform);
window.Components = { // 全局组件
    toast: Object.assign((msg) => {
        // 当消息为空时不显示toast
        if (msg === '' || msg === undefined || msg === null) {
            return;
        }
        // 支持字符串和对象两种参数形式
        if (typeof msg === 'object' && msg.message !== undefined &&
            (msg.message === '' || msg.message === null)) {
            return;
        }
        Toast(msg);
    }, {
        loading: Toast.loading,
        success: Toast.success,
        fail: Toast.fail,
        clear: Toast.clear,
        allowMultiple: Toast.allowMultiple,
        setDefaultOptions: Toast.setDefaultOptions,
        resetDefaultOptions: Toast.resetDefaultOptions
    })
};

window.sdkBridge = {};
window.natiCallJS = function (paramsObj) {
    console.log('natiCallJS', paramsObj)
    if (window.sdkBridge && paramsObj.callbackId && window.sdkBridge[paramsObj.callbackId]) {
        window.sdkBridge[paramsObj.callbackId](paramsObj.data)
        delete window.sdkBridge[paramsObj.callbackId]
    }
    if (window.sdkBridge && paramsObj.event && window.sdkBridge[paramsObj.event]) {
        window.sdkBridge[paramsObj.event](paramsObj.data)
    }
};

//快速查找工作区监听
// if(process.env.NODE_ENV  == "development"){
//     try {
//         openCodeClient.init();
//     } catch (error) {
//         console.log(error)
//     }
// }
const app = createApp(AppVue);

// 增加全局错误处理器
app.config.errorHandler = (err, instance, info) => {
    console.error('Vue错误:', err);
    console.error('来源:', info);

    // 针对DOM操作错误特殊处理
    if (err && err.message && (
        err.message.includes('insertBefore') ||
        err.message.includes('Node') ||
        err.message.includes('DOM'))) {
        console.warn('捕获到DOM操作错误，已阻止应用崩溃');
        // 这里可以尝试恢复应用状态或进行其他降级处理
    }
};

// 关闭生产环境警告
app.config.warnHandler = (msg, instance, trace) => {
    // 在开发环境显示警告，生产环境忽略
    if (import.meta.env.DEV) {
        console.warn(msg);
        console.info(trace);
    }
};

// 设置性能选项
app.config.performance = import.meta.env.DEV;

app.use(store).use(router).use(Toast).mount('#app');
